<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$archive"
				start
			/>
			<translate>Archived Adyen settlement report files</translate>
		</v-card-title>
		<v-card-text>
			<translate>
				Here are the last 20 Adyen settlement report files that have been processed.
			</translate>
			<model-backend-table
				:sort-by="[{key: sortBy, order: sortDesc}]"
				endpoint="/api/v0/adyensettlementreportfiles"
				:headers="tableHeaders"
				:items-per-page="20"
				:items-per-page-options="[20]"
			>
				<template #item.originalFileName="{ item }">
					<a :href="`/bo/finance/settlementreport/view?id=${item.id}`">
						{{ item.originalFileName }}
					</a>
				</template>
				<template #item.export="{ item }">
					<v-btn
						class="d-flex"
						color="primary"
						variant="text"
						@click="requestExport(item.id)"
					>
						<translate>Export</translate>
					</v-btn>
				</template>
				<template #item.user="{ item }">
					{{ item.user.nameInitials }} {{ item.user.nameLast }}
				</template>
			</model-backend-table>
		</v-card-text>
	</v-card>
</template>

<script>

export default {
	name: 'ArchivedAdyenSettlementReports',
	data () {
		return {
			options: {
			},
			sortDesc: true,
			sortBy: 'id'
		};
	},
	computed: {
		tableHeaders () {
			return [
				{
					title: 'id', value: 'id', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Filename'), value: 'originalFileName', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Processed'), value: 'processedAt', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Last downloaded at'), value: 'lastDownloadedAt', sortable: false,
				},
			];
		},
	},
};
</script>

<style scoped>

</style>
